// extracted by mini-css-extract-plugin
export default {"mobile-filters":"styles_mobile-filters__g0njj"};